<template>
<div>我是秋天</div>
</template>

<script>
export default {
  name: "Autumn"
}
</script>

<style scoped>
div{
  width: 100px;
  height: 100px;
  margin: 0 auto;
  background: #c27d54;
}
</style>